import {
  CheckOutlined,
  ClockCircleOutlined,
  CloseOutlined,
  MinusCircleOutlined,
} from '@ant-design/icons';
import * as React from 'react';
import { ColoredTag } from 'components/Custom/spans';
import {
  UPLOAD_STATUS_TAG_STYLES,
  UploadStatusTagVariant,
  getUploadStatusShortLabel,
  getUploadStatusTagVariant,
} from 'utils/uploadStatusHelpers';

const TAG_ICONS: Record<UploadStatusTagVariant, React.ReactNode> = {
  success: <CheckOutlined />,
  error: <CloseOutlined style={{ color: '#D13131' }} />,
  info: <ClockCircleOutlined />,
  warning: <ClockCircleOutlined />,
  default: <MinusCircleOutlined />,
};

interface UploadStatusTagProps {
  status: unknown;
  style?: React.CSSProperties;
}

export const UploadStatusTag: React.FC<UploadStatusTagProps> = ({
  status,
  style,
}) => {
  const variant = getUploadStatusTagVariant(status);
  const label = getUploadStatusShortLabel(status);
  const colors = UPLOAD_STATUS_TAG_STYLES[variant];

  return (
    <ColoredTag
      style={{ margin: 0, flexShrink: 0, ...style }}
      color={colors.color}
      bgcolor={colors.background}
      bordered
      bordercolor={colors.border}
      icon={TAG_ICONS[variant]}
      $smaller
    >
      {label}
    </ColoredTag>
  );
};
